import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"7.5\" cy=\"1.5\" r=\"1.5\" fill=\"currentColor\"></circle><circle cx=\"7.5\" cy=\"8.5\" r=\"1.5\" fill=\"currentColor\"></circle><circle cx=\"7.5\" cy=\"15.501\" r=\"1.5\" fill=\"currentColor\"></circle><circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\" fill=\"currentColor\"></circle><circle cx=\"1.5\" cy=\"8.5\" r=\"1.5\" fill=\"currentColor\"></circle><circle cx=\"1.5\" cy=\"15.5\" r=\"1.5\" fill=\"currentColor\"></circle>", 6)
  ]))]))
}
export default { render: render }